const PRACTICE_STATUSES = [
  {
    label: 'Active',
    value: 'active'
  },
  {
    label: 'Inactive',
    value: 'inactive'
  },
  {
    label: 'Pending',
    value: 'pending'
  }
];

const PRACTICE_REGIONS = [
  {
    label: 'East Coast',
    value: 'East Coast'
  },
  {
    label: 'West Coast',
    value: 'West Coast'
  }
];

export const FILTERS_DEFS = {
  id: {
    title: 'Practice ID',
    values: null,
    allowed_operators: ['contains', 'does not contain'],
    icon: 'text-num-mono'
  },
  practice: {
    queryKey: 'practices.options',
    title: 'Practice',
    placeholder: 'Search practice',
    icon: 'user-mono',
    allowed_operators: ['is', 'is not', 'is any of']
  },
  dba_name: {
    title: 'DBA',
    values: null,
    allowed_operators: ['contains', 'does not contain'],
    icon: 'first-line-mono'
  },
  phone: {
    title: 'Phone',
    values: null,
    allowed_operators: ['contains', 'does not contain'],
    icon: 'call-calling-mono'
  },
  timezone: {
    title: 'Timezone',
    values: null,
    allowed_operators: ['contains', 'does not contain'],
    icon: 'timezone-mono'
  },
  status: {
    title: 'Status',
    placeholder: 'Search by status',
    multiple: true,
    queryFn: (_, data) => {
      const searchTerm = data.filters.searchTerm || '';
      return {
        options: PRACTICE_STATUSES.filter((status) =>
          status.label.toLowerCase().includes(searchTerm.toLowerCase())
        )
      };
    },
    queryKey: 'admin_practice_statuses.options',
    icon: 'status-mono'
  },
  region: {
    title: 'Region',
    placeholder: 'Search by region',
    multiple: true,
    queryFn: (_, data) => {
      const searchTerm = data.filters.searchTerm || '';
      return {
        options: PRACTICE_REGIONS.filter((region) =>
          region.label.toLowerCase().includes(searchTerm.toLowerCase())
        )
      };
    },
    queryKey: 'practice_regions.options',
    icon: 'location-mono'
  }
};

export const navigateToVistProfile = (navigate, id) => {
  navigate(`/admin/practitioners/${id}`);
};
